import type { IComponentController, IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IProfileService } from "App/Modules/Auth";

import type { IModalService } from "App/Modules/Services";

import "angular-translate";

import type { IEnumService, IProfile, IResponseWithLoading, IUserNotificationSettings } from "App/Modules/Models";
import { NotificationChannel, Permission } from "App/Modules/Models";

import { extendWithLoadingAndFail } from "../../../../Services/ObservableExtensions";

export default class ProfileNotificationSettingsComponentController implements IComponentController {
    public static $inject = ["$scope", "$translate", "mmModalService", "mmProfileService", "mmEnumService"];

    public notificationChannels: Array<{ key: number; value: string }>;

    public profile: IProfile;

    public notificationSettings: IResponseWithLoading<IUserNotificationSettings[]>;

    public subCaption = "";

    constructor(
        private $scope: IScope,
        private $translate: angular.translate.ITranslateService,
        private readonly modalService: IModalService,
        private profileService: IProfileService,
        private enumService: IEnumService,
    ) {}

    public $onInit() {
        this.notificationChannels = this.enumService.enumToArray(NotificationChannel);
        if (this.profile.userPermissions.partnerPermissions.find((item) => item === Permission.SiteInformation)) {
            extendWithLoadingAndFail(this.profileService.getNotificationSettings())
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (result) => {
                        this.notificationSettings = result;
                    },
                    (result) => {
                        this.notificationSettings = result;
                    },
                );
        }

        this.$scope.$watch<IUserNotificationSettings[]>(
            "$ctrl.notificationSettings.data",
            (newValue) => {
                if (newValue && newValue.length) {
                    this.$translate(
                        "Entities.NotificationSubscription.NumSubscriptionsFormat",
                        { numSubscriptions: newValue.length },
                        "messageformat",
                    ).then((subCaption) => {
                        this.subCaption = subCaption;
                    });
                } else {
                    this.subCaption = "";
                }
            },
            true,
        );
    }

    public editNotificationSettings() {
        this.modalService
            .open("mmProfileNotificationSettingsEdit", this.notificationSettings.data)
            .subscribe((notificationSettings) => {
                this.notificationSettings.data = notificationSettings;
            });
    }
}
